import { render, staticRenderFns } from "./RestaurantsHeroImageIssues.vue?vue&type=template&id=1a9ca434&scoped=true"
import script from "./RestaurantsHeroImageIssues.vue?vue&type=script&lang=js"
export * from "./RestaurantsHeroImageIssues.vue?vue&type=script&lang=js"
import style0 from "./RestaurantsHeroImageIssues.vue?vue&type=style&index=0&id=1a9ca434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ca434",
  null
  
)

export default component.exports